import { render, staticRenderFns } from "./HotelBooking.vue?vue&type=template&id=562d6c7c&"
import script from "./HotelBooking.vue?vue&type=script&lang=ts&"
export * from "./HotelBooking.vue?vue&type=script&lang=ts&"
import style0 from "./HotelBooking.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports